import React from "react"
import loadable from '@loadable/component'

import Img from "gatsby-image";
import CustomMarkdown from "../utils/customMarkdown.js"
import GetImgUrl, { abc } from "../utils/customFunctions";
// import TopWhiteSwirl from "../assets/SVG/WhiteSwirlTop.svg";
// import TopDarkSwirl from "../assets/SVG/DarkSwirlTop.svg";
// import BottomDarkSwirl from "../assets/SVG/DarkSwirlBottom.svg";
// import BottomWhiteSwirl from "../assets/SVG/WhiteSwirlBottom.svg";
import "../scss/components/paragraph.scss" 
import "../scss/components/swirl-component.scss" 

const SwirlComponent = loadable(() => import("./swirl-component.js"))

const Paragraph = ({ title, text, image, imagePosition, bgColor, topPadding, bottomPadding,  forceH1Title, alignment, topSwirl, bottomSwirl, bottomMargin, overlaySwirl, hasLateralPadding }) => {
    const bgClassName = bgColor =="White" ? "white-component" : "dark-component";
    const paddingTop = topPadding ? 'padding-top' : '';
    const paddingBottom = bottomPadding ? 'padding-bottom' : '';
    const marginBottom = bottomMargin ? 'margin-bottom' : '';
    const contentAlignment = alignment == 'center' ? 'content-center' : alignment == 'left' ? 'content-left' : alignment == 'right' ? 'content-right' : '';
    //const overlaySwirlClass = overlaySwirl == true ? "overlay-swirl" : '';
    const contentMarginTopMobileOverlay = overlaySwirl == true ? "content-margin-top-mobile" : '';
    const lateraPaddingClass = hasLateralPadding == true ? "lateral-padding" : '';

    // const topWhiteSwirlStyle = {
    //     backgroundImage: `url(${TopWhiteSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };
    //   const topDarkSwirlStyle = {
    //     backgroundImage: `url(${TopDarkSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };
    //   const bottomDarkSwirlStyle = {
    //     backgroundImage: `url(${BottomDarkSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };
    //   const bottomWhiteSwirlStyle = {
    //     backgroundImage: `url(${BottomWhiteSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };
    if(image !== null && imagePosition !== "None"){
        const imageFluid =  GetImgUrl(image.localFile___NODE).fluid;
        var verticalSpaceDivider = "";
        if(forceH1Title){
            verticalSpaceDivider = "uk-grid-divider";
        }
        //has image
        switch(imagePosition){
            case "Left30":
            case "Left70":
            case "Left50":
            default:
                var imageContainerWidth = "";
                var contentContainerWidth = "";
                var squareImageClassname = "";
                var verticalAlignCenter = "";
               
                if(imagePosition == "Left30"){
                    imageContainerWidth = "uk-width-1-3@m";
                    contentContainerWidth = "uk-width-2-3@m";
                }else if(imagePosition == "Left70"){
                    imageContainerWidth = "uk-width-2-3@m";
                    contentContainerWidth = "uk-width-1-3@m";
                }else if(imagePosition == "Left50"){
                    imageContainerWidth = "uk-width-1-2@m";
                    contentContainerWidth = "uk-width-1-2@m";
                    squareImageClassname = "square-image-container";
                    verticalAlignCenter = "vertical-align-center";
                }              
                return(                  
                    <div className={`paragraph-component ${contentAlignment} ${marginBottom}`}>
                        {topSwirl ? <SwirlComponent bgColor={bgColor} topSwirl={true} overlaySwirl={overlaySwirl}></SwirlComponent> : ''}
                        {/* {topSwirl ? (bgColor == "White") ? <div className={`swirl-image ${overlaySwirlClass}`} style={topWhiteSwirlStyle}></div> : <div className={`swirl-image ${overlaySwirlClass}`} style={topDarkSwirlStyle}></div> : ''} */}
                        <div className={`side-image-section ${bgClassName} ${paddingTop} ${paddingBottom} ${lateraPaddingClass} ${contentMarginTopMobileOverlay}`}>                   
                            <div className={`uk-child-width-expand@s uk-grid uk-margin-remove ${verticalSpaceDivider}`} data-uk-grid>
                                <div className={`${imageContainerWidth} uk-text-center uk-padding-remove uk-cover-container uk-margin-remove`}>
                                    <Img
                                        className={'paragraph-image ' + squareImageClassname}
                                        fluid={imageFluid}
                                        alt="image.alternativeText"
                                        data-uk-cover                           
                                    ></Img>                                
                                </div>
                                <div className={`${contentContainerWidth} ${verticalAlignCenter} padding-left paragraph-content uk-margin-remove`}>
                                    {title ? (forceH1Title) ? <h1 className={'side-image-paragraph-title'}>{title}</h1> : <h2 className={'side-image-paragraph-title'}>{title}</h2> : ''}
                      
                                    <div className="side-image-paragraph-text">
                                        <CustomMarkdown children={text} />
                                    </div>

                                </div>
                            </div>
                        </div>
                        {bottomSwirl ? <SwirlComponent bgColor={bgColor} topSwirl={false}></SwirlComponent> : ''}
                        {/* {bottomSwirl ? (bgColor == "White") ? <div className="swirl-image" style={bottomWhiteSwirlStyle}></div> : <div className="swirl-image" style={bottomDarkSwirlStyle}></div> : ''} */}
                    </div >
                );

            case "Right30":
            case "Right70":
            case "Right50":
                var imageContainerWidth = "";
                var contentContainerWidth = "";
                var squareImageClassname = "";
                var verticalAlignCenter = "";
                if(imagePosition == "Right30"){
                    imageContainerWidth = "uk-width-1-3@m";
                    contentContainerWidth = "uk-width-2-3@m";
                }else if(imagePosition == "Right70"){
                    imageContainerWidth = "uk-width-2-3@m";
                    contentContainerWidth = "uk-width-1-3@m";
                }else if(imagePosition == "Right50"){
                    imageContainerWidth = "uk-width-1-2@m";
                    contentContainerWidth = "uk-width-1-2@m";
                    squareImageClassname = "square-image-container";
                    verticalAlignCenter = "vertical-align-center";
                }
                return(
                    <div className={`paragraph-component ${contentAlignment} ${marginBottom}`}>
                        {topSwirl ? <SwirlComponent bgColor={bgColor} topSwirl={true} overlaySwirl={overlaySwirl}></SwirlComponent> : ''}
                        {/* {topSwirl ? (bgColor == "White") ? <div className={`swirl-image ${overlaySwirlClass}`} style={topWhiteSwirlStyle}></div> : <div className={`swirl-image ${overlaySwirlClass}`} style={topDarkSwirlStyle}></div> : ''} */}
                        <div className={`side-image-section ${bgClassName} ${paddingTop} ${paddingBottom} ${lateraPaddingClass} ${contentMarginTopMobileOverlay}`}>
                            <div className={`uk-child-width-expand@s uk-grid uk-margin-remove ${verticalSpaceDivider}`} data-uk-grid>
                                <div className={`${contentContainerWidth} ${verticalAlignCenter} paragraph-content padding-right`}>
                                    {title ? (forceH1Title) ? <h1 className={'side-image-paragraph-title'}>{title}</h1> : <h2 className={'side-image-paragraph-title'}>{title}</h2> : ''}
                            
                                        <div className="side-image-paragraph-text">
                                            <CustomMarkdown children={text} />
                                        </div>
                                </div>
                                <div className={`${imageContainerWidth} uk-text-center uk-padding-remove uk-cover-container`}>
                                    <Img
                                        className={'paragraph-image ' + squareImageClassname}
                                        fluid={imageFluid}
                                        alt="image.alternativeText"
                                        data-uk-cover
                                    ></Img>                                  
                                </div>
                            </div>
                        </div>
                        {bottomSwirl ? <SwirlComponent bgColor={bgColor} topSwirl={false}></SwirlComponent> : ''}
                        {/* {bottomSwirl ? (bgColor == "White") ? <div className="swirl-image" style={bottomWhiteSwirlStyle}></div> : <div className="swirl-image" style={bottomDarkSwirlStyle}></div> : ''} */}
                    </div >
                );
        }
    }else{
        //no image
        return(
            <div className={`paragraph-component ${contentAlignment} ${marginBottom}`}>
                {topSwirl ? <SwirlComponent bgColor={bgColor} topSwirl={true} overlaySwirl={overlaySwirl}></SwirlComponent> : ''}
                {/* {topSwirl ? (bgColor == "White") ? <div className={`swirl-image ${overlaySwirlClass}`} style={topWhiteSwirlStyle}></div> : <div className={`swirl-image ${overlaySwirlClass}`} style={topDarkSwirlStyle}></div> : ''} */}
                <div className={`${bgClassName} ${paddingTop} ${paddingBottom} ${lateraPaddingClass} ${contentMarginTopMobileOverlay}`}>
                    <div className={`paragraph-content`}>
                        {title ? (forceH1Title) ? <h1 className={'no-image-paragraph-title'}>{title}</h1> : <h2 className={'no-image-paragraph-title'}>{title}</h2> : ''}
                
                            <div className="no-image-paragraph-text">
                                <CustomMarkdown children={text} />
                            </div>
                    </div> 
                </div>
               
                {bottomSwirl ? <SwirlComponent bgColor={bgColor} topSwirl={false}></SwirlComponent> : ''}
                {/* {bottomSwirl ? (bgColor == "White") ? <div className="swirl-image" style={bottomWhiteSwirlStyle}></div> : <div className="swirl-image" style={bottomDarkSwirlStyle}></div> : ''}               */}
            </div >
        );
    }

}

export default Paragraph